import { useSelector } from 'react-redux';
import * as ReportGenerationStore from '../../../../../../redux/reportGeneration';
import { window } from '../../../../../../globals';
import styles from '../SidePanel.module.less';
import { ProjectType, ReportCategories } from '../../utils';
import PublicLinkButton from './PublicReportButton';
import EmailButton from './EmailReportButton';
import DownloadButton from './DownloadReportButton';
import PaidFeatureGate from '../../../../../generic/Gates/PaidFeatureGate';
import ReadOnlySection from '../../../../../generic/ReadOnlySection';
import PaidPill from '../../../../../generic/Pill/PaidPill';
import Flex from '../../../../../generic/Flex';
import { isFreeTier, PREMIUM_COMPLIANCE_PLAN_NAME } from '../../../../../../../shared/subscriptions';

const ReportDistributionPanel = () => {
  const projectType = useSelector(ReportGenerationStore.selectors.getProjectType);
  const category = useSelector(ReportGenerationStore.selectors.getCategory);
  const shouldEmailReport = useSelector(ReportGenerationStore.selectors.getShouldEmailReport);

  const reportContext = useSelector(ReportGenerationStore.selectors.getReportContext);
  const reportOptions = useSelector(ReportGenerationStore.selectors.getReportOptions);
  const isPaidFeatureGateRestricted = isFreeTier({
    plan: window?.user?.organization?.stripe_plan,
    stripePriceLimit: window?.user?.organization?.stripePriceLimit,
  });

  return (
    <div className={styles.reportDistributionPanel}>
      <div className="panel-heading text-center">Distribute to Users</div>
      <div className={styles.reportDistributionPanelContent}>
        {category !== ReportCategories.Vulnerability && projectType !== ProjectType.ReleaseGroup && (
          <PaidFeatureGate
            isRestricted={isPaidFeatureGateRestricted}
            useReadOnly={false}
            hidePill
            planToShow={PREMIUM_COMPLIANCE_PLAN_NAME}
          >
            <Flex direction="row" gap="8px" justify="space-between">
              <ReadOnlySection isReadOnly={isPaidFeatureGateRestricted} isClickable={isPaidFeatureGateRestricted}>
                <span>Link to this file</span>
              </ReadOnlySection>
              {isPaidFeatureGateRestricted && <PaidPill />}
            </Flex>
            <PublicLinkButton
              isDisabled={isPaidFeatureGateRestricted}
              reportContext={reportContext}
              reportOptions={reportOptions}
            />
          </PaidFeatureGate>
        )}
        <Flex direction="row" gap="8px" justify="space-between">
          <span>Download and distribute yourself</span>
        </Flex>
        {shouldEmailReport ? (
          <EmailButton reportContext={reportContext} reportOptions={reportOptions} />
        ) : (
          <DownloadButton reportContext={reportContext} reportOptions={reportOptions} />
        )}
      </div>
    </div>
  );
};

export default ReportDistributionPanel;
